import React from 'react';

var _ = require('lodash');

function CustomerTypeLabelCase(customerType) {
  switch(customerType) {
    case "CUSTOMER": {
      return "Khách hàng lẻ"
    }
    case "CUSTOMER_AGENCY": {
      return "Khách hàng của đại lý"
    }
    case "AGENCY": {
      return "Đại lý"
    }
    default: {
      return "Tất cả"
    }
  }
}

class CustomerTypeSelect extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {customer_type_selected, onCustomerTypeSelect} = this.props;
    const options = [
      {label: "Tất cả", value: "ALL"},
      {label: "Khách hàng lẻ", value: "CUSTOMER"},
      {label: "Khách hàng của đại lý", value: "CUSTOMER_AGENCY"},
      {label: "Đại lý", value: "AGENCY"},
    ]
    const customer_types = _.map(options, (i,index) => {
      return <a key={index} onClick={() => onCustomerTypeSelect(i.value)} className="dropdown-item">{i.label}</a>
    })
    return(
      <React.Fragment>
        <div style={{ float: 'right', margin: 5}} className="btn-group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            {CustomerTypeLabelCase(customer_type_selected)}
          </button>
          <div className="dropdown-menu" x-placement="bottom-start">
             {customer_types}
          </div>
        </div>
      </React.Fragment>
    )
  }

}


export default CustomerTypeSelect;